import { IAccessory, IExterior } from 'interfaces/buildAndPrice';
import { IInitialData } from 'redux/slices/vehicleSlice';

function getOptionList(accessories: IAccessory[]) {
  const optionList = accessories.map((accessory) => {
    const {
      opCode,
      name,
      enName,
      price,
      priceBundle,
      rules,
      hidden,
      showInIri,
      thumbnail,
      hasIRIAssets,
      iriZOrder,
      categoryName,
    } = accessory;
    return {
      DisplayGroups: [],
      ExcludeList: rules.excludes,
      IncludeList: rules.includes,
      IncludedByList: rules.includedBy,
      OpCode: opCode,
      OptionAssetList: [],
      OptionColorList: [],
      OptionCustomAttributeList: [],
      OptionDealerPrice: price,
      OptionName: name,
      enName: enName,
      OptionPrice: price,
      PriceBundle: priceBundle,
      RequiredByList: rules.requiredBy,
      RequiredList: rules.requires,
      isHidden: hidden,
      showInIri: showInIri,
      Thumb: thumbnail,
      hasIRIAssets: hasIRIAssets,
      iriZOrder: iriZOrder,
      categoryName: categoryName,
    };
  });
  return optionList;
}

function getOptionPackageList(accessories: IAccessory[]) {
  const optionPackageList = accessories
    .filter((accessory) => accessory.rules.includes.length > 0)
    .map((accessory) => {
      const { opCode, price, rules } = accessory;
      const includedOptionsList = rules.includes.map((opCode) => {
        return { OpCode: opCode, IsSelected: false };
      });

      return {
        IncludedOptionsList: includedOptionsList,
        IsSelected: false,
        OpCode: opCode,
        TotalDealerPrice: '',
        TotalOptions: rules.includes.length,
        TotalPrice: price,
        TotalSelectedOptions: 0,
      };
    });

  return optionPackageList;
}

function getColorComboList(colorCombinations: IExterior[]) {
  const colorComboList: any = {};
  colorCombinations.forEach((colorComb) => {
    const deltaPrice = colorComb.color.deltaPrice || '0';
    const interiorColors = colorComb.interiors.map((interior) => {
      return {
        ColorCode: interior.code,
        isDefaultInteriorColor: false,
      };
    });
    // || '' used to be consistent with manufacturingCode undefined state for packages
    colorComboList[colorComb.color.manufacturingCode || ''] = {
      PriceDelta: parseInt(deltaPrice, 10),
      InteriorColors: interiorColors,
    };
  });

  return colorComboList;
}

function getExteriorColorList(colorCombinations: IExterior[]) {
  return colorCombinations.map((colorComb) => {
    const { code, name, manufacturingCode, deltaPrice } = colorComb.color;
    return {
      ColorIdent: code,
      ColorName: name,
      ColorMfgCode: manufacturingCode,
      PriceDelta: deltaPrice,
      IsSelected: false,
    };
  });
}

function getInteriorColorList(colorCombinations: IExterior[]) {
  const interiorColors = colorCombinations
    .map((colorComb) => {
      return colorComb.interiors;
    })
    .flat();

  return interiorColors.map((interior) => {
    const { id, name, code, manufacturingCode } = interior;
    return {
      ColorIdent: id,
      ColorName: name,
      ColorCode: code,
      ColorMfgCode: manufacturingCode,
      PriceDelta: null,
      IsSelected: false,
    };
  });
}

export function parseInitialData(data: IInitialData) {
  const { colorCombinations, accessories, model, vehicleData } = data;
  const { modelID, modelSeries, modelYear } = vehicleData;
  const colorComboList = getColorComboList(colorCombinations);
  const exteriorColorList = getExteriorColorList(colorCombinations);
  const interiorColorList = getInteriorColorList(colorCombinations);
  const optionList = getOptionList(accessories);
  const optionPackageList = getOptionPackageList(accessories);
  return [
    {
      ModelId: modelID,
      ModelName: modelSeries,
      ModelMarketingName: `${modelYear} ${modelSeries}`,
      MSRP: model.msrp,
      ModelYear: modelYear,
      DestinationHandling: model.destinationCharge,
      LaborRate: '0',
      TotalPrice: '0',
      TotalDealerPrice: '0',
      isLeased: false,
      Lease: null,
      DealerNumber: '',
      ColorComboList: colorComboList,
      ExteriorColors: exteriorColorList,
      InteriorColors: interiorColorList,
      ModelAssetList: [],
      ModelAttributeList: [],
      ModelCustomAttributeList: [],
      ModelFIFCategoryList: [],
      ModelFIFList: [],
      ModelFeatureList: [],
      ModelHighlightFeature: 'Missing',
      ModelOptionList: optionList,
      ModelOptionPackageList: optionPackageList,
    },
  ];
}
